import { UserProfileExtendedInfo } from '../types';

const EMPTY_EXTENDED_INFO: UserProfileExtendedInfo = {
  college: '',
  degree: '',
  educationStatus: '',
  isWorking: false,
  companyName: '',
  role: '',
  location: '',
  address: '',
};

export function parseUserInfoJson(userInfoJson?: string | null): UserProfileExtendedInfo {
  if (!userInfoJson?.trim()) {
    return { ...EMPTY_EXTENDED_INFO };
  }

  try {
    const parsed = JSON.parse(userInfoJson) as Partial<UserProfileExtendedInfo>;
    return {
      college: parsed.college ?? '',
      degree: parsed.degree ?? '',
      educationStatus: parsed.educationStatus ?? '',
      isWorking: Boolean(parsed.isWorking),
      companyName: parsed.companyName ?? '',
      role: parsed.role ?? '',
      location: parsed.location ?? '',
      address: parsed.address ?? '',
    };
  } catch {
    return { ...EMPTY_EXTENDED_INFO };
  }
}

export function buildUserInfoJson(info: UserProfileExtendedInfo): string {
  const payload: UserProfileExtendedInfo = {
    college: info.college?.trim() || undefined,
    degree: info.degree?.trim() || undefined,
    educationStatus: info.educationStatus || undefined,
    isWorking: info.isWorking ?? false,
    companyName: info.isWorking ? info.companyName?.trim() || undefined : undefined,
    role: info.isWorking ? info.role?.trim() || undefined : undefined,
    location: info.location?.trim() || undefined,
    address: info.address?.trim() || undefined,
  };

  return JSON.stringify(payload);
}

export function displayProfileValue(value?: string | null): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : 'Not available';
}

export function displayEducationStatus(status?: string | null): string {
  if (status === 'completed') return 'Completed';
  if (status === 'pursuing') return 'Pursuing';
  return 'Not available';
}

export function displayWorkingStatus(isWorking?: boolean | null): string {
  if (isWorking === true) return 'Yes';
  if (isWorking === false) return 'No';
  return 'Not available';
}
